import { useTranslation } from "react-i18next";
import { closeWizard } from "src/modules/pairing/duck/actions";
import Dialog from "src/components/Dialog";
import { useDispatch } from "react-redux";

export default function FailureDialog() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const button = {
    text: t("buttons.ok"),
    onClick: () => {
      dispatch(closeWizard());
    }
  };
  const text = t(`pairing.failureDialog.text`);
  const heading = t(`pairing.failureDialog.heading`);

  return (
    <Dialog
      isOpen={true}
      type="failure"
      buttons={[button]}
      heading={heading}
      text={text}
    />
  );
}
